<template>
  <div id="app">
    <!-- 页面头部导航 -->
    <sw-header />
    <!-- 页面主体内容 -->
    <div class="app-con">
      <router-view />
    </div>
    <!-- 页面右侧导航 -->
    <sw-right-nav @onConsult="onConsult" />
    <!-- 页面底部导航 -->
    <sw-footer />
    <!-- 移动端底部导航 -->
    <min-phone-nav @onConsult="onConsult" />
  </div>
</template>
<script>
import SwHeader from "@/components/SwHeader.vue"
import SwFooter from "@/components/SwFooter.vue"
import SwRightNav from "@/components/SwRightNav.vue"
import MinPhoneNav from '@/components/MinPhoneNav.vue'
import { mapState } from 'vuex'
export default {
  name: "App",
  components: { SwHeader, SwFooter, SwRightNav, MinPhoneNav },
  data () {
    return {
      pathName: '',
      consultVisible: false
    }
  },
  computed: {
    ...mapState([
      'stayConsultation',
    ]),
  },
  watch: {
    '$route.path' () {
      this.pathName = this.$route.name
      // 切换路由页面回到顶部
      window.scrollTo(0, 0)
    },
    'stayConsultation' (val) {
      if(val){
        this.consultVisible = true
        this.$nextTick(() => {
          this.$refs.consult.init()
        })
      }
    },
  },
  mounted(){
    if (!this.$route.name) {
      this.$router.push({ path: '/' })
    }
    this.pathName = this.$route.name
    // 等待企微相关JS文件加载完成，调用初始化方法
     setTimeout(() => {
        // eslint-disable-next-line no-undef
        wlCustomFormComp.init({
          wl_id: "ww66791c90425dba05", // 企业的唯一id,在代码文档.txt中获得
        })
      }, 2000)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll,100);
  },
  methods: {
    onConsult () {
      this.consultVisible = true
      this.$nextTick(() => {
        this.$refs.consult.init()
      })
    }
  }
};
</script>
<style lang="scss">
#app{
  width: 100%;
  min-width: 1200px;
}
.app-con {
  min-height: 1200px;
  width: 100%;
  min-width: 1200px;
  margin: 0 auto;
}
.homeHeaderFixed {
  position: fixed;
  width: 100%;
  top: 0px;
  z-index: 1001;
}
@media screen and (max-width: 980px) {
  #app{
    width: 100%;
    min-width: 100%;
  }
  .app-con {
    min-height: 100%;
    width: 100%;
    min-width: 100%;
    margin: 0 auto;
  }
}
</style>
